import {Theme, createTheme } from '@mui/material/styles';
export const darkTheme: Theme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

